import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const FilterOrderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
